import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import HelpIcon from '@material-ui/icons/HelpOutline';
import IconButton from '@material-ui/core/IconButton';

const HelpContentModal = ({ content, label }) => {
  const [show, setSHow] = useState(false);
  if (!content) return label || null;

  return (
    <>
      {label && <span>{label}</span>}
      <IconButton size="small" onClick={() => setSHow(!show)}>
        <HelpIcon fontSize="small" />
      </IconButton>
      {show && (
        <Box
          bgcolor="background.default"
          p={2}
          mt={2}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </>
  );
};

export default HelpContentModal;
